import React,{Component} from 'react'

let timer;

class Filters extends Component{
    constructor(props){
        super(props);

    }

    handleFilterChange(field,value){
        let {data} = this.props
        let filters = {
            ...data,
            [field]:value
        }

        return filters;
    }
    handleFilterChangeAndThrow(field,value){
        this.funcThrowFilters(this.handleFilterChange(field,value));
    }
    handleOnStatusChange(e){
        this.handleFilterChangeAndThrow("status",e.target.value)
    }
    handleOnChangeShard(e){
        let value = e.target.value

        let filters = this.handleFilterChange("shard",value)

        clearTimeout(timer);

        timer = setTimeout(()=>{
            this.funcThrowFilters(filters);
        },500)
    }
    handleOnReset() {
        this.shard.value = ""
        if (this.props.onReset) {
            this.props.onReset();
        }
    }

    funcThrowFilters(filters) {
        if (this.props.onFiltersChange) {
            this.props.onFiltersChange(filters);
        }
    }

    render(){
        let {data} = this.props
        return(
            <div className="c-filters">
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label>Статус: </label>
                            <select className="select form-control" value={data.status} onChange={(e) => this.handleOnStatusChange(e)}>
                                <option value="null">Все</option>
                                <option value="true">Активные</option>
                                <option value="false">Не активные</option>
                            </select>

                        </div>
                    </div>

                    <div className="col-md-3">
                        <div className="form-group">
                            <label>Шард: </label>
                            <input
                                className="form-control"
                                ref={(input)=>this.shard = input}
                                onChange={(e)=>this.handleOnChangeShard(e)}
                            />
                        </div>
                    </div>

                    <div className="col-md-3 filters-controls col-md-offset-3">
                        <div className="row">
                            <div className="col-sm-6">
                                {/* <button className="btn btn-submit" >Принять</button> */}
                            </div>
                            <div className="col-sm-6">
                                <button className="btn btn-reset" onClick={() => this.handleOnReset()}>Сбросить</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }

}

export default Filters


// WEBPACK FOOTER //
// ./src/components/Admin/Companies/Filters.jsx